import { Card, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
 import { areaSpalineChart as originalAreaSpalineChart } from "../../../data/dashboard/ChartData";
import { H6 } from "../../../AbstractElements";
import { useAppSelector } from "../../../redux-tool-kit/Hooks";
import CardHeaderCommon from "../../../common-elements/card-header-common/CardHeaderCommon";

interface SeriesItem {
  name: string;
  data: number[];
}

const MobileUserStatsChart = () => {
  const originalSeries =
    (originalAreaSpalineChart.series as SeriesItem[]) || [];
  const seriesWithoutName = originalSeries.map(({ data }) => ({ data }));
  const areaSpalineChart = {
    ...originalAreaSpalineChart,
    series: seriesWithoutName,
    legend: { show: false },
  };
  const totalUsers = originalSeries.reduce(
    (sum: number, series: SeriesItem) =>
      sum +
      series.data.reduce((acc: number, val: number) => acc + Number(val), 0),
    0
  );
  const darkMode = useAppSelector((state) => state.layout.darkMode);

  return (
    <Col sm="12" xl="5" className="m-0">
      <Card>
        <CardHeaderCommon title="Mobile User Growth & CRM Sales" />
        <CardBody>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              width: "100%",
            }}
          >
            <div style={{ width: "100%" }}>
              <ReactApexChart
                options={areaSpalineChart}
                series={areaSpalineChart.series}
                type="area"
                height={290}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                margin: "12px 0 0 0",
              }}
            >
              {originalSeries.map((s, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "-20px",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      background:
                        (areaSpalineChart.colors &&
                          areaSpalineChart.colors[idx]) ||
                        "#ccc",
                      border: "1px solid #bbb",
                      marginRight: "4px",
                    }}
                  />
                  <p
                    style={{
                      color: darkMode ? "#fff" : "#333",
                      fontSize: "0.65rem",
                    }}
                  >
                    {s.name}
                  </p>
                </div>
              ))}
            </div>
            <div
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                color: "#333",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              <H6>Total Users: {totalUsers}</H6>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MobileUserStatsChart;
